import personalLoanCalculatorApi from '../../api/personal-loan-calculator-2021-api';
const PERSONAL_LOAN_CALCULATOR_CONFIG_RESPONSE = 'personalLoanCalculatorConfigResponse';
const PERSONAL_LOAN_CALCULATOR_CONFIG_FAILURE = 'personalLoanCalculatorConfigFailure';
const PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_RESPONSE = 'personalLoanCalculatorLoanSelectResponse';
const PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_FAILURE = 'personalLoanCalculatorLoanSelectFailure';
const PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_RESPONSE = 'personalLoanCalculatorAmountCalculationResponse';
const PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_FAILURE = 'personalLoanCalculatorAmountCalculationFailure';
const PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_RESPONSE = 'personalLoanCalculatorMonthlyFeeCalculationResponse';
const PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_FAILURE = 'personalLoanCalculatorMonthlyFeeCalculationFailure';
const PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_AMOUNT_FORM_DATA = 'personalLoanCalculatorSetAmountCalculationFormData';
const PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_MONTHLY_FEE_FORM_DATA = 'personalLoanCalculatorSetMonthlyFeeCalculationFormData';
const PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_HIGHER_INCOME = 'personalLoanCalculatorSetCalculationHigherIncome';

const personalLoanCalculatorState = {
	loading: false,
	technicalError: false,
	initConfigData: null,
	selectData: [],
	loanCalculationResponse: null,
	monthlyFeeCalculationResponse: false,
	calculationAmountFormData: null,
	calculationMonthlyFeeFormData: null,
	higherIncome: false
};

const personalLoanCalculatorActions = {
	getConfig({ commit }) {
		return new Promise((resolve, reject) => {
			personalLoanCalculatorApi
				.getConfig()
				.then((response) => {
					commit(PERSONAL_LOAN_CALCULATOR_CONFIG_RESPONSE, response.data);
					resolve();
				})
				.catch((error) => {
					commit(PERSONAL_LOAN_CALCULATOR_CONFIG_FAILURE, error.data);
					reject();
				});
		});
	},
	getSelectValues({ commit }) {
		personalLoanCalculatorApi
			.getSelectValues()
			.then((response) => {
				commit(PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_RESPONSE, response.data);
			})
			.catch((error) => {
				commit(PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_FAILURE, error.data);
			});
	},
	calculateAmount({ commit, state }, params) {
		if (state.initConfigData && state.initConfigData.uuid) {
			commit(PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_AMOUNT_FORM_DATA, params);
			personalLoanCalculatorApi
				.calculateAmount(
					Object.assign({}, params, {
						uuid: state.initConfigData.uuid,
						higherIncome: state.higherIncome
					})
				)
				.then((response) => {
					commit(PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_RESPONSE, response.data);
				})
				.catch((error) => {
					commit(PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_FAILURE, error.data);
				});
		}
	},
	calculateMonthlyFee({ commit, state }, params) {
		if (state.initConfigData && state.initConfigData.uuid) {
			commit(PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_MONTHLY_FEE_FORM_DATA, params);
			personalLoanCalculatorApi
				.calculateMonthlyFee(
					Object.assign({}, params, {
						uuid: state.initConfigData.uuid,
						higherIncome: state.higherIncome
					})
				)
				.then((response) => {
					commit(PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_RESPONSE, response.data);
				})
				.catch((error) => {
					commit(PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_FAILURE, error.data);
				});
		}
	},
	sendTa(context, taData) {
		personalLoanCalculatorApi.sendTa(taData);
	},
	setHigherIncome({ commit }, higherIncome) {
		commit(PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_HIGHER_INCOME, higherIncome);
	}
};

const personalLoanCalculatorMutations = {
	[PERSONAL_LOAN_CALCULATOR_CONFIG_RESPONSE](state, data) {
		state.initConfigData = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_CONFIG_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_RESPONSE](state, data) {
		state.selectData = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_LOAN_SELECT_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_RESPONSE](state, data) {
		state.loanCalculationResponse = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_AMOUNT_CALCULATION_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_RESPONSE](state, data) {
		state.monthlyFeeCalculationResponse = data;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_MONTHLY_FEE_CALCULATION_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_AMOUNT_FORM_DATA](state, calculationAmountFormData) {
		state.calculationAmountFormData = calculationAmountFormData;
	},
	[PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_MONTHLY_FEE_FORM_DATA](state, calculationMonthlyFeeFormData) {
		state.calculationMonthlyFeeFormData = calculationMonthlyFeeFormData;
	},
	[PERSONAL_LOAN_CALCULATOR_SET_CALCULATION_HIGHER_INCOME](state, higherIncome) {
		state.higherIncome = higherIncome;
	}
};

export default {
	namespaced: true,
	state: personalLoanCalculatorState,
	mutations: personalLoanCalculatorMutations,
	actions: personalLoanCalculatorActions
};
